import httpService from "./httpService";

export const availableApi = (data, ln) => {
  return httpService.get(`hotel/v2/hotel/availability`, {
    ...data,
    ln,
  });
};

export const paymentApi = (data) => {
  return httpService.get("payments/v1/gateways/hotel", data);
};

export const bookingTokenApi = (data) => {
  return httpService.post("users/v1/getOrCreateCustomerBookingToken", data);
};

export const createBookingApi = (data) => {
  return httpService.post("hotel/authorised/v1/bookings", data);
};

export const createOrderApi = (data) => {
  return httpService.post("payments/authorized/v2/order/", data);
};

export const sendOtpApi = (data) => {
  return httpService.post("payments/authorized/v2/order/success", data);
};

export const searchApi = (data) => {
  return httpService.get("hotel/v1/bookings", data);
};

export const bookingApi = (data) => {
  return httpService.get("hotel/v1/bookings", data);
};

export const viewApi = (id, obj) => {
  return httpService.put(`hotel/v1/hotel/${id}/view`, obj);
};

export const whatsappViewApi = (id, obj) => {
  return httpService.put(`hotel/v1/hotel/${id}/whatsapp`, obj);
};

export const fetchReviewRatingApi = (placeid) => {
  return httpService.get(`hotel/v1/hotel/reviews?placeId=${placeid}`);
};

export const fetchReviewRatingApi2 = (hotelId) => {
  return httpService.get(`hotel/v2/hotel/reviews?hotelId=${hotelId}`);
};

// `https://dev2-api.hotelzify.com/hotel/v2/hotel/reviews?hotelId=${hotelId}`

export const fetchNearByPlacesApi = (id, lat, long) => {
  return httpService.get(
    `hotel/v1/hotel/nearbylocation?hotelId=${id}&latitude=${lat}&longitude=${long}`
  );
};

export const fetchNearPlacesV2Api = (id, lat, long) => {
  return httpService.get(
    `/hotel/v2/hotel/nearby-locations?latitude=${lat}&longitude=${long}&hotelId=${id}`
  );
};

export const fetchPendingReasonsApi = () => {
  return httpService.get(
    "hotel/authorised/v2/hotel/lookups?type=pending_reason&ln=en"
  );
};

export const updatePendingReasonsApi = (obj) => {
  return httpService.post("hotel/authorised/v1/abandonReason", obj);
};

export const updatePendingReasonsUnauthorizedApi = (obj) => {
  return httpService.post("hotel/v1/abandonReason", obj);
};

export const fetchSocialMediaPostsApi = (userName) => {
  return httpService.get(`hotel/v1/hotel/instagramData?userName=${userName}`);
};

export const fetchPromotionsApi = (url) => {
  return httpService.get(`hotel/v2/promotions/get-promotion?hotelId=${url}`);
};

export const fetchFAQApi = (id) => {
  return httpService.get(`hotel/v1/faq/get-faq?hotelId=${id}`);
};

export const postFAQApi = (obj) => {
  return httpService.post(`hotel/v1/faq/add-faq`, obj);
};

export const fetchPoliciesApi = (hotelId, ln) => {
  return httpService.get(`hotel/v2/hotel/policies/${hotelId}?ln=${ln}`);
};

export const cancelBookingApi = (hotelId, dailCode, mobile) => {
  return httpService.get(
    `hotel/v1/bookings/get-my-booking?dialCode=%2b${dailCode}&mobile=${mobile}&hotelId=${hotelId}`
  );
};

export const cancelBookingWithIdApi = (obj) => {
  return httpService.post(`hotel/v1/bookings/cancel`, obj);
};

export const cancelInfoApi = (obj) => {
  return httpService.post("hotel/v1/bookings/cancel/info", obj);
};

export const reportApi = (id, type) => {
  return httpService.put(`hotel/v1/hotel/${id}/${type}`);
};

export const priceUpdateApi = (obj) => {
  return httpService.post("hotel/v1/bookings/confirmation", obj);
};

export const tripPlannerApi = (obj) => {
  return httpService.post("hotel/v1/hotel/travel-planner", obj);
};

export const checkIsLowestApi = (id, checkIn) => {
  return httpService.get(
    `hotel/v1/hotel/is-lowest?hotelId=${id}&checkIn=${checkIn}`
  );
};

export const autiFillApi = (dialCode, mobile) => {
  return httpService.get(
    `hotel/v1/bookings/autofill?dialCode=${dialCode}&mobile=${mobile}`
  );
};

export const dumpHighPrice = (obj) => {
  return httpService.post("hotel/v1/abandonReason/price-enquiry", obj);
};

export const getCouponApi = (id) => {
  return httpService.get(`hotel/v1/hotel/getBling?hotelId=${id}`);
};

export const getNewPaymentArrayApi = (id) => {
  return httpService.get(`payments/v2/order/paymentDetails?bookingId=${id}`);
};

export const getAboutUsInfoApi = (id) => {
  return httpService.get(`hotel/v1/profile/getProfile?hotelId=${id}`);
};

export const findAllKeywordsApi = (obj) => {
  return httpService.post("hotel/v1/hotel/findAllKeyWords", obj);
};

export const getLivePriceApi = (obj) => {
  return httpService.get("hotel/v1/hotel/get-my-price-in-google-slow", obj);
};

export const razorpayKeyApi = (hotelId) => {
  return httpService.get(
    `/payments/v1/gateways/gateway-key?hotelId=${hotelId}`
  );
};

export const fetchSitemaplinksApi = () => {
  return httpService.get("hotel/v1/hotel/slugs-list");
};

export const getPromotionByIdApi = (id, hotelId) => {
  return httpService.get(
    `hotel/v2/promotions/get-promotion-id?id=${id}&hotelId=${hotelId}`
  );
};

export const checkIfVideoCallEnabledApi = (hotelId) => {
  return httpService.get(
    `hotel/v1/videoCalling/isCallEnabled?hotelId=${hotelId}`
  );
};

export const createMeetingIdApi = (obj) => {
  return httpService.post(`hotel/v1/videoCalling/createCall`, obj);
};

export const deactivateMeetingRoomApi = (meetingId) => {
  return httpService.post(
    `hotel/v1/videoCalling/deactivateMeetingRoom/${meetingId}`
  );
};

export const startRecordingApi = (obj) => {
  return httpService.post(`hotel/v1/videoCalling/start/recording`, obj);
};

export const getWeeksInventoryApi = (obj) => {
  return httpService.get(`hotel/v1/pricing_and_inventory/calendar-list`, obj);
};

export const getTaxSlabsApi = (hotelId) => {
  return httpService.get(
    `payments/v1/tax/list?hotelId=${hotelId}&page=1&pageSize=100&getDefaultTaxes=false`
  );
};

export const priceLogsApi = (obj) => {
  return httpService.post("hotel/v1/bookings/prices-logs", obj);
};

export const isRoomAvailableApi = (obj) => {
  return httpService.post("hotel/v1/bookings/is-room-available", obj);
};

export const validateCouponApi = (obj) => {
  return httpService.post("hotel/v2/promotions/validate-coupon-codes", obj);
};

export const getDetailedBookingsApi = (id) => {
  return httpService.get(`hotel/v2/bookings/${id}`);
};

export const modifyBookingsApi = (obj) => {
  return httpService.post("hotel/authorised/v1/bookings/modify-booking", obj);
};

export const getPaymentProviderApi = (hotelId) => {
  return httpService.get(
    `payments/v1/gateways/payment-provider?hotelId=${hotelId}`
  );
};

export const getBNPLConfigApi = (hotelId) => {
  return httpService.get(`/hotel/v1/hotel/bnpl-config?hotelId=${hotelId}`);
};

export const callBotApi = (obj) => {
  return httpService.post(`api/call`, obj);
};

export const getScriptTagIdApi = (hotelId) => {
  return httpService.get(`hotel/v1/chatbot/scripttag?hotelId=${hotelId}`);
};

export const getLowestPriceApi = (obj) => {
  return httpService.post("hotel/v1/hotel/scraper/get-latest-price", obj);
};

export const getRetargetingDiscountApi = (hotelId) => {
  return httpService.get(
    `hotel/v2/promotions/retargeting-promotion-hotel?hotelId=${hotelId}`
  );
};

export const otpCreateLoginAccount = (obj) => {
  return httpService.post(`users/v1/otpCreateLoginAccount`, obj);
};

export const otpLoginAccount = (obj) => {
  return httpService.post(`users/v1/otpLoginAccount`, obj);
};

export const verifyOtpLoginAccount = (obj) => {
  return httpService.post(`users/v1/verifyOtpLoginAccount`, obj);
};
export const sendOtpEmailApi = (obj) => {
  return httpService.post(`users/v1/isExistAndSendOtpEmail`, obj);
};

export const verifyOTPEmail = (obj) => {
  return httpService.post("users/v1/verifyOtpEmail", obj);
};

export const sendOtpPhone = (data) => {
  return httpService.post("users/v1/otpLoginAccount", data);
};

export const verifyOTPPhone = (data) => {
  return httpService.post("users/v1/verifyOtp", data);
};

export const verifyOtpCreateLoginAccount = (obj) => {
  return httpService.post(`users/v1/verifyOtpCreateLoginAccount`, obj);
};

export const isRoomsAvailable = (obj) => {
  return httpService.post("hotel/v2/bookings/is-rooms-available", obj);
};
export const notifyIfNoInventory = (obj) => {
  return httpService.post("hotel/v1/hotel/inventory-retargtting", obj);
};
export const gethotelVideosAPI = (hotelId) => {
  return httpService.get(`hotel/v1/hotel/get-videos?hotelId=${hotelId}`);
};
